import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';

import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import {  Observable, throwError } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ComponentBase } from '../components/base/common-base';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor extends ComponentBase implements HttpInterceptor {
  constructor(
    private readonly toastr: ToastrService,
    private readonly spinner: NgxSpinnerService,
    private readonly router: Router
  ) {
    super();
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            if (event.status === 200) {
              this.spinner.hide();
            }
          }
        },
      }),
      catchError((error: HttpErrorResponse) => {
        // let errorMsg = '';
        this.loading = false;
        if (error?.error instanceof ErrorEvent) {
          this.spinner.hide();

          // errorMsg = `Error: ${error.error.message}`;
        } else {
          this.handleServerSideError(error);
          // errorMsg = `Error Code: ${error?.status},  Message: ${error?.message}`;
        }
        return throwError(error);
      })
    );
  }

  handleServerSideError(error: HttpErrorResponse): void {
    this.spinner.hide();
    this.loading = false;
    if (error.status === 403) {

      this.router.navigate(['/unauthorized'])
    }
    // switch (error?.status) {
    //   case 401:
    //     this.toastr.error('You are not authorized , Please login again !');

    //     break;

    //   case 403:
    //     this.toastr.error(error?.error?.title);
    //     break;

    //   case 402:
    //     this.toastr.error(error?.error?.title);
    //     break;

    //   case 422:
    //     this.toastr.error(error?.error?.title);
    //     break;

    //   case 400:
    //     this.toastr.error(error?.error?.title);
    //     break;

    //   case 412:
    //     this.toastr.error(error?.error?.title);
    //     break;

    //   case 500:
    //     this.toastr.error('SERVER ERROR, TRY AGAIN  !');
    //     break;

    //   case 425:
    //     this.toastr.error(error?.error?.title);
    //     break;

    //   case 415:
    //     this.toastr.error(error?.error?.title);
    //     break;

    //   case 404:
    //     this.toastr.error(error?.error?.title);
    //     break;
    // }
  }
}
